export const roomActionTypes = {
    SET_WAITING_ROOMS: 'SET_WAITING_ROOMS',
    SET_NEW_INPROGRESS_ROOMS: 'SET_NEW_INPROGRESS_ROOMS',
    REMOVE_INPROGRESS_ROOMS: 'REMOVE_INPROGRESS_ROOMS',
    SET_HISTORY_ROOMS: 'SET_HISTORY_ROOMS',
    SET_SHOW_SENDING_MESSAGE: 'SET_SHOW_SENDING_MESSAGE',
    GET_SHOW_SENDING_MESSAGE: 'GET_SHOW_SENDING_MESSAGE',
    SET_CURRENT_ROOMID: 'SET_CURRENT_ROOMID',
    SET_CURRENT_ROOM: 'SET_CURRENT_ROOM',
    SET_ROOM_ALERT: 'SET_ROOM_ALERT',
    SET_VIEWED_ROOMS: 'SET_VIEWED_ROOMS',
};